module.exports = __webpack_public_path__ + "static/bansat-93b11c897b6c8c18b26f361ca534eb5f.png";